<template>
  <div class="rooms w1200">
      <div class="menus">
        <div class="menu"></div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      roomsData:[],
    }
  },
  created(){
    console.log(this.$route.query);
  },
}
</script>

<style lang="scss" scoped>
  .rooms{
    margin-top: 60px;

  }
</style>